import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { MailSendEnvelopeIcon, ShareIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
const ghostButtonCss = "g10xro8s";
const GhostButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(ghostButtonCss, props.className)} />);
export const ShareAvailabilityButton = ({
  onClick,
  isButtonExperimentEnabled
}) => isButtonExperimentEnabled ? <Button decoration="outline" onClick={onClick} size="small" responsive={false}>
      <ShareIcon data-testid="share-icon" spacingRight={4} />
      <p>{I18n.t('publisher.contacts.buttons.share_availability')}</p>
    </Button> : <GhostButton decoration="ghost" onClick={onClick} responsive={false}>
      <MailSendEnvelopeIcon data-testid="envelope-icon" />
      <p>{I18n.t('publisher.contacts.buttons.share_availability')}</p>
    </GhostButton>;

require("./share_availability_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./share_availability_button.js");